export const experiences = [
    {
        "company": "CONTUS",
        "location": "Chennai",
        "position": "Application Developer ",
        "website": "",
        "startDate": "Nov 2018",
        "highlights": [
            "Plan, develop and implement successful large-scale projects from conception to completion",
            "Ability to understand/comment on functional requirements and design documents",
            "Involved in analysis, design, and development, customization, testing and troubleshooting",
            "Project handling on all phases of the development life cycle, from analysis to deployment on the production environment, to post-release support",
            "Communicating with the client team, mobile and web team for the development, integration and troubleshooting",
        ],
        "endDate": "Present"
    },
    {
        "company": "AMTEX SYSTEMS",
        "location": "Chennai",
        "position": "Application Programmer ",
        "website": "",
        "startDate": "May 2016",
        "highlights": [
            "Communicating with the clients to gather requirements, and preparing SRS Document with sequence flow",
            "Involved in analysis, design, and development, customization, testing and troubleshooting",
            "Plan, develop and implement successful large-scale projects from conception to completion",
            "Handling migrations form alpha and 1.0 version CMS to 2.0",
            "Analysing and implementing ETL process through python scripts",
            "Involving and handling all phases of the development life cycle, from SRS to product delivery, and post-release support",
        ],
        "endDate": "Nov 2018"
    }
]